import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import logoParking from "../../asses/img/logo-parking.png";

export default function TerminosyCondicionesMensualidadNatural() {
  return (
    <>
      <Container className="mtop-30 tyc-container">
        <Row className="justify-content-center mtop-20 mbottom-20">
          <Col xs={12}>
            {/* HEADER */}
            

              <div className="tyc-header-text">
                <h1>TÉRMINOS Y CONDICIONES PARA MENSUALIDADES</h1>
                <h1>A USUARIO PERSONA NATURAL</h1>

                <p className="tyc-meta">
                  <span>Versión: 01</span>
                  <br />
                  <span>Fecha: 13 de noviembre de 2025</span>
                </p>
              </div>
            
          </Col>
        </Row>

        {/* CONTENIDO */}
        <Row>
          <Col xs={12}>
            <article className="tyc-body">
        <h2>I. Introducción</h2>

        <p>
          Parking International S.A.S. (en adelante “Parking”) es una sociedad
          constituida bajo las leyes colombianas, identificada con NIT
          860.058.760-1 y con domicilio en Bogotá D.C. Su objeto social es
          operar parqueaderos para todo tipo de vehículos, incluyendo la
          instalación, mantenimiento y operación de zonas de parqueo tanto en
          vía como fuera de vía.
        </p>

        <p>
          El presente documento, denominado{" "}
          <strong>
            Términos y Condiciones para Mensualidades a Usuario de Persona
            Natural
          </strong>{" "}
          regula los términos del servicio que presta Parking en el territorio
          colombiano.
        </p>

        <h2>II. Definiciones</h2>

        <ul>
          <li>
            <strong>a. Be Parking:</strong> Programa de fidelización de Parking
            mediante el cual se otorga beneficios a las personas registradas en
            el programa de conformidad con los términos y condiciones
            publicados en{" "}
            <a
              href="https://beparking.com.co/termsAndContitions"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://beparking.com.co/termsAndContitions
            </a>
            .
          </li>
          <li>
            <strong>b. Datos Personales:</strong> Es toda información que
            permite identificar o hacer identificable a una persona natural.
          </li>
          <li>
            <strong>c. Derecho de admisión:</strong> Facultad que tiene Parking,
            por medio de sus representantes, de permitir o denegar el ingreso de
            Usuarios, Usuarios Beneficiarios y Clientes Corporativos al
            Parqueadero, de conformidad con los criterios dispuestos en el
            capítulo XVIII de estos términos y condiciones.
          </li>
          <li>
            <strong>d. Operario:</strong> Persona responsable de la gestión
            diaria del parqueadero, incluyendo la recepción y entrega de
            vehículos, el cobro de tarifas, el mantenimiento del orden y la
            seguridad, así como la atención a los clientes.
          </li>
          <li>
            <strong>e. Página web:</strong> Página mediante la cual el Usuario
            podrá gestionar sus productos y consultar información general de
            Parking, la cual se encuentra en el siguiente enlace:{" "}
            <a
              href="https://www.parking.net.co"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.parking.net.co
            </a>
            .
          </li>
          <li>
            <strong>f. Parqueadero:</strong> Establecimiento de Parking en el
            cual se presta el servicio.
          </li>
          <li>
            <strong>g. Titular:</strong> Persona natural cuyos Datos Personales
            son objeto de Tratamiento.
          </li>
          <li>
            <strong>h. Tratamiento:</strong> Es cualquier operación o conjunto
            de operaciones sobre Datos Personales, tales como la recolección,
            almacenamiento, uso, circulación o supresión.
          </li>
          <li>
            <strong>i. Usuario:</strong> Persona natural que utiliza los
            Servicios ofrecidos por Parking.
          </li>
          <li>
            <strong>j. Vehículo:</strong> Bien mueble dejado en custodia de
            Parking, el cual puede ser carro, moto, bicicleta o patineta
            eléctrica.
          </li>
        </ul>

        <h2>III. Servicio</h2>

        <p>
          A continuación, se establecen los términos y condiciones del servicio
          que presta Parking de mensualidad para usuarios o clientes persona
          natural. Lo anterior, sin perjuicio de que Parking, en cualquier
          momento, pueda modificarlos o unificarlos con otros servicios que
          preste en un mismo documento de términos y condiciones generales.
        </p>

        <h3>a. Mensualidad para persona natural</h3>

        <p>
          Derecho para estacionar durante un (1) mes calendario durante el
          horario establecido en cada Estacionamiento:
        </p>

        <ul>
          <li>El Usuario seleccionará un (1) parqueadero a su conveniencia.</li>
          <li>
            El Usuario podrá registrar hasta dos (2) placas por mensualidad de
            carro o una (1) placa por mensualidad de moto o bicicleta.
          </li>
          <li>
            El Usuario podrá estacionar solamente una (1) placa al mismo tiempo
            en el mismo estacionamiento. En caso de encontrarse estacionado uno
            de los vehículos registrados, los demás deberán pagar la tarifa
            establecida para el público.
          </li>
          <li>
            El servicio podrá utilizarse solamente en el parqueadero elegido por
            el Usuario al momento del registro.
          </li>
          <li>
            La mensualidad iniciará una vez se realice el pago anticipado, y
            podrá quedar habilitada dentro de las cinco (5) horas siguientes a
            la recepción del pago.
          </li>
          <li>
            Aplican las políticas de responsabilidad que se encuentran
            publicadas en los avisos del Parqueadero y al revés del ticket de
            ingreso.
          </li>
          <li>
            En caso de que el Usuario incumpla los presentes T&amp;C, Parking
            podrá cancelar la mensualidad de forma inmediata y el Usuario no
            podrá reclamar por el dinero restante hasta la finalización de la
            mensualidad.
          </li>
          <li>
            El Usuario acepta la Política de Tratamiento de Datos Personales, la
            cual está disponible para su consulta a través de las Plataformas,
            en el siguiente enlace:{" "}
            <a
              href="https://www.parking.net.co/politicadetratamientodedatospersonales"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.parking.net.co/politicadetratamientodedatospersonales
            </a>
            . Mediante esta aceptación, reconoce y comprende el tratamiento que
            se dará a sus datos personales, los derechos que le asisten y los
            canales de comunicación habilitados para su ejercicio.
          </li>
          <li>
            El Usuario acepta que el servicio de estacionamiento se prestará de
            acuerdo con las obligaciones que la ley vigente exija a Parking en
            esta materia.
          </li>
          <li>
            Se permite UN solo cambio de placas dentro del mes calendario. Dicho
            cambio podrá realizarse en cualquier tiempo a través de la App o
            página web.
          </li>
          <li>
            En ninguna circunstancia se realizarán congelamientos ni
            suspensiones de las mensualidades vigentes.
          </li>
          <li>
            En caso de cierre del parqueadero, se realizará la devolución del
            pago proporcional a los días en los cuales el Usuario no haya podido
            utilizarlo. La devolución se hará de conformidad con lo indicado en
            el capítulo XIII de estos T&amp;C.
          </li>
          <li>
            En ninguna circunstancia se realizarán devoluciones una vez pagado
            el servicio. No obstante, el Usuario podrá ejercer su derecho de
            retracto y solicitar el reembolso en los términos establecidos en el
            artículo 45 de la Ley 1480 de 2011 y de conformidad con lo indicado
            en estos T&amp;C.
          </li>
          <li>
            En caso de abandono de vehículos o bienes no sujetos a registro, se
            llevará a cabo el procedimiento establecido en el Decreto 1413 de
            2018 y el Estatuto del Consumidor, así como las normas que
            complementen, modifiquen y/o sustituyan estas disposiciones. El
            vehículo se considerará abandonado transcurridos dos (2) meses desde
            la notificación por parte de Parking.
          </li>
          <li>
            El servicio de mensualidad está asociado exclusivamente a las placas
            registradas, es intransferible entre personas.
          </li>
          <li>
            La vigencia de este servicio es de treinta (30) días calendario
            contados desde el momento del pago del Servicio.
          </li>
          <li>
            Aplica única y exclusivamente dentro de los Parqueaderos donde se
            adquirió el servicio de mensualidad.
          </li>
          <li>
            El uso del servicio por mensualidad no está incluido dentro del
            programa de lealtad Be Parking.
          </li>
          <li>
            En caso de utilizar el servicio de parqueadero por fuera del horario
            de prestación del servicio, se aplicará la tarifa al público durante
            el tiempo en que el vehículo quede bajo la custodia de Parking.
          </li>
          <li>
            El Usuario tendrá la posibilidad de renovar su derecho de
            mensualidad en el momento que lo considere pertinente, ampliando los
            términos y condiciones aceptados.
          </li>
          <li>
            Fuera del horario de prestación del servicio, no se entenderá
            celebrado ningún contrato de depósito entre el Usuario y Parking. En
            tal caso, Parking no asumirá responsabilidad alguna por el vehículo.
            Durante estos periodos no operativos, la custodia y vigilancia del
            vehículo serán de exclusiva responsabilidad del Usuario, quien
            asume todos los riesgos derivados de su permanencia en el
            establecimiento fuera del horario autorizado.
          </li>
          <li>No acumula puntos Be Parking.</li>
        </ul>

        <h2>IV. Limitaciones de responsabilidad de Parking</h2>

        <p>
          En relación con la prestación del servicio de parqueadero, Parking
          informa que no puede garantizar un servicio ininterrumpido ni libre de
          errores, ya que estos pueden surgir por factores ajenos o atribuibles
          al Usuario. No obstante, Parking se compromete a resolver cualquier
          inconveniente dentro de sus posibilidades y a indemnizar al Usuario
          conforme a las normas de protección al consumidor, siempre y cuando se
          compruebe que Parking tiene responsabilidad directa. Esta
          indemnización aplicará únicamente si el Usuario estaba utilizando
          activamente el Servicio y el vehículo se encontraba dentro del
          establecimiento en el momento de los daños o inconvenientes.
        </p>

        <p>
          Fuera del horario de prestación del servicio, no se entenderá que
          exista un contrato de depósito entre el Usuario y Parking. En
          consecuencia, Parking no asumirá responsabilidad alguna por el
          vehículo. Durante estos periodos no operativos, la custodia y
          vigilancia del vehículo recaerán exclusivamente en el Usuario, quien
          asume los riesgos derivados de su permanencia en el establecimiento
          fuera del horario autorizado.
        </p>

        <p>
          En el caso de los Usuarios con mensualidad, cuyo uso también está
          sujeto al horario de funcionamiento del parqueadero, si al momento del
          cierre el vehículo permanece dentro del establecimiento, el operador
          definirá el procedimiento mediante el cual se informará al Usuario el
          estado del vehículo. Esta medida tiene como propósito dejar
          constancia de las condiciones en que se encuentra el vehículo al
          cierre de la operación, pues después del horario de prestación del
          servicio, el Usuario asume la responsabilidad del vehículo.
        </p>

        <h2>V. Canales para solicitar información sobre la presentación de PQRS</h2>

        <p>
          El Usuario dispone de varios canales a su disposición para solicitar
          información sobre las plataformas, ejercer sus derechos, presentar
          peticiones, quejas o reclamos de manera directa:
        </p>

        <ul>
          <li>
            Visite nuestro sitio web{" "}
            <a
              href="https://www.parking.net.co"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.parking.net.co
            </a>
          </li>
          <li>
            Comuníquese a nuestra línea telefónica de atención al cliente +57
            300 910 9787.
          </li>
          <li>
            Contáctenos por medio del correo electrónico:{" "}
            <a href="mailto:servicioalcliente@parking.net.co">
              servicioalcliente@parking.net.co
            </a>
          </li>
          <li>
            Otros canales que se habiliten para este fin publicados en la
            página web.
          </li>
        </ul>

        <h2>VI. Aviso de privacidad y política de tratamiento de la información personal</h2>

        <p>
          Al aceptar los presentes términos y condiciones, el Usuario/Cliente
          Corporativo declara de manera libre, expresa, informada e inequívoca
          que ha leído en su totalidad, ha comprendido y acepta íntegramente el
          tratamiento de datos personales y por ende la Política de Tratamiento
          de Datos Personales de Parking International S.A.S., identificada con
          N.I.T. 860.058.760-1, con domicilio en la Carrera 14 No. 89-48,
          Oficina 202, Bogotá, Colombia, teléfono: 2342277 y correo
          electrónico:{" "}
          <a href="mailto:administracion@parking.net.co">
            administracion@parking.net.co
          </a>
          , para realizar el tratamiento de los datos personales suministrados,
          de acuerdo con las finalidades y condiciones establecidas en la
          Política de Tratamiento de Datos Personales, la cual forma parte
          integral y vinculante de esta autorización y puede ser consultada en
          el siguiente enlace:{" "}
          <a
            href="https://www.parking.net.co/politicadetratamientodedatospersonales"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.parking.net.co/politicadetratamientodedatospersonales
          </a>
          .
        </p>

        <p>
          En cumplimiento de lo dispuesto en la Ley 1581 de 2012 y en los
          artículos 2.2.2.25.3.2 y siguientes del Decreto 1074 de 2015, el
          Usuario/Cliente Corporativo autoriza a Parking International S.A.S.
          para recolectar, verificar, procesar, archivar, reportar, consultar,
          almacenar, usar, transmitir y transferir sus datos personales, con las
          finalidades establecidas en la Política de Tratamiento de Datos
          Personales, entre las cuales se incluyen, pero no se limitan a:
        </p>

        <ul>
          <li>
            Gestionar la relación contractual, comercial o de servicio con el
            Usuario/Cliente Corporativo.
          </li>
          <li>
            Contactarlo para aspectos operativos y comerciales relacionados con
            los servicios de Parking.
          </li>
          <li>
            Informarle sobre novedades, mejoras o actualizaciones de los
            servicios.
          </li>
          <li>
            Transmitir o compartir los datos personales del Usuario/Cliente
            Corporativo con aliados estratégicos, contratistas, proveedores,
            plataformas tecnológicas o terceros con los que Parking International
            S.A.S. tenga relación comercial o legal, con el fin de ejecutar
            actividades relacionadas con la prestación, mejora y personalización
            de los servicios, programas de fidelización, beneficios, atención al
            cliente, actividades promocionales, analítica de datos o cualquier
            otra finalidad autorizada conforme a la Política de Tratamiento de
            Datos Personales.
          </li>
          <li>
            Consultar y reportar información a centrales de riesgo.
          </li>
          <li>
            Enviar información publicitaria, promocional o de interés comercial
            relacionada con los productos, servicios o actividades de Parking
            International S.A.S., o de sus aliados estratégicos, a través de
            medios físicos, electrónicos o digitales.
          </li>
          <li>
            Realizar análisis de riesgos para la prevención y detección de
            actividades ilícitas, incluyendo, pero no limitándose a lavado de
            activos, financiación del terrorismo, soborno y demás delitos.
          </li>
          <li>
            Al descargar y aceptar los Términos y Condiciones de la aplicación,
            el Usuario/Cliente Corporativo autoriza de manera expresa el
            tratamiento de sus datos personales para su afiliación automática al
            programa de fidelización “Be Parking” o a cualquier otro programa de
            beneficios, fidelización, aplicaciones digitales o similares que
            implemente Parking International S.A.S., o sus aliados estratégicos.
            Esta afiliación incluye la gestión y participación en dichos
            programas, el envío de información sobre beneficios, promociones,
            acumulación o redención de puntos, y demás actividades relacionadas
            con su operación. Asimismo, el Usuario/Cliente Corporativo acepta
            que sus datos sean registrados automáticamente en aplicaciones,
            plataformas o sistemas digitales desarrollados o gestionados por
            Parking International S.A.S., o sus aliados estratégicos, para la
            correcta administración y disfrute de los programas mencionados.
            Para tal efecto, los datos podrán ser compartidos, transmitidos o
            transferidos a terceros, aliados estratégicos o encargados
            involucrados en la administración, operación o desarrollo de dichos
            programas, siempre bajo los términos y condiciones establecidos en
            la Política de Tratamiento de Datos Personales.
          </li>
          <li>
            Gestionar la atención de consultas, quejas, reclamos o peticiones
            realizadas por el Usuario/Cliente Corporativo a través de los
            canales dispuestos por Parking International S.A.S.
          </li>
          <li>
            Mantener registros históricos, administrativos y contables como
            parte de los sistemas de información internos.
          </li>
        </ul>

        <p>
          El Usuario/Cliente Corporativo tiene derecho a conocer, actualizar,
          rectificar y suprimir sus datos, así como a solicitar prueba de la
          autorización otorgada o revocarla en cualquier momento. Para ejercer
          estos derechos, podrá comunicarse a través de los canales de atención
          dispuestos en la Política de Tratamiento de Datos Personales.
        </p>

        <h2>VII. Otras disposiciones</h2>

        <ul>
          <li>
            <strong>Cesión:</strong> El Usuario/Cliente Corporativo no podrá
            ceder ni transferir estas Condiciones, en todo o en parte, sin el
            consentimiento previo por escrito de Parking. El Usuario/Cliente
            Corporativo da su aprobación a Parking para ceder o transferir estas
            Condiciones, en todo o en parte, incluido a: (i) un aliado; (ii) una
            subsidiaria o un afiliado; (iii) un adquirente del capital, del
            negocio o de los activos de Parking; o (iv) un sucesor por fusión.
            No existe entre el Usuario, Parking o cualquier tercero proveedor
            una empresa conjunta o relación de socios, empleo o agencia como
            resultado del contrato entre el Usuario y Parking o del uso de los
            Servicios.
          </li>
          <li>
            <strong>Ley vigente:</strong> Estos Términos de uso se regirán e
            interpretarán de conformidad con las leyes de la República de
            Colombia.
          </li>
          <li>
            <strong>Propiedad intelectual:</strong> Todas las marcas registradas
            de Parking, marcas de servicio, nombres comerciales, logotipos,
            nombres de dominio y cualquier otra característica de la marca
            Parking y Go Parking son propiedad exclusiva de Parking o sus
            licenciantes. La prestación del servicio y uso de la App no le
            otorga derecho alguno al Usuario y al Cliente Corporativo para usar
            las características de la marca Parking y Go Parking, ya sea para
            uso comercial o no comercial.
          </li>
          <li>
            <strong>Comunicaciones electrónicas:</strong> El Usuario/Cliente
            Corporativo autoriza que el correo electrónico proporcionado en el
            registro será el medio de comunicación respecto de la información
            relativa a su cuenta (por ejemplo, las autorizaciones de pago, las
            facturas, el QR, los cambios de contraseña o de la forma de pago,
            los mensajes de confirmación, los avisos).
          </li>
          <li>
            <strong>Continuación de vigencia:</strong> Si alguna de las
            disposiciones de estos T&amp;C es declarada nula, ilegal o
            inaplicable, la validez, legalidad y aplicación de las demás
            disposiciones se mantendrán incólumes y seguirán siendo aplicadas.
          </li>
          <li>
            <strong>Indemnidad:</strong> El Usuario/Cliente Corporativo acuerda
            mantener indemne y responder frente a Parking y sus consejeros,
            directores, empleados y agentes por cualquier reclamación, demanda,
            pérdida, responsabilidad y gasto (incluidos los honorarios de
            abogados) que se deriven de: (i) el uso indebido de las Plataformas,
            los productos y/o servicios que se oferten en la misma; (ii) su
            incumplimiento o violación de cualquiera de estas Condiciones;
            (iii) el uso por parte de Parking de su contenido de Usuario; o (iv)
            su infracción de los derechos de cualquier tercero, incluidos
            terceros proveedores.
          </li>
        </ul>

        <h2>VIII. Derecho de admisión</h2>

        <p>
          Parking se reserva el derecho de admisión a los parqueaderos con el
          fin de garantizar un entorno seguro y ordenado para todos los
          Usuarios y se basa en los siguientes criterios:
        </p>

        <ul>
          <li>
            <strong>Comportamiento:</strong> Se prohíbe el acceso a personas
            cuyo comportamiento sea inapropiado, disruptivo o que infrinja las
            normas establecidas. Esto incluye, pero no se limita a, actitudes
            agresivas, lenguaje ofensivo y violaciones a las reglas de conducta
            del parqueadero.
          </li>
          <li>
            <strong>Seguridad:</strong> Para mantener la seguridad de nuestros
            Usuarios y la integridad del parqueadero, nos reservamos el derecho
            de denegar el acceso a personas que puedan poner en riesgo tanto la
            seguridad del parqueadero como la seguridad de los operarios y los
            Usuarios, así como también se podrá denegar el acceso a los
            vehículos que no cumplan con los requisitos de seguridad
            establecidos, como aquellos en mal estado o que no cuenten con la
            documentación adecuada.
          </li>
          <li>
            <strong>Cumplimiento de normas:</strong> El acceso puede ser
            restringido a quienes no cumplan con las normas de uso del
            parqueadero, incluyendo el pago de tarifas, el uso adecuado de los
            espacios asignados y el respeto a las señales e indicaciones del
            personal.
          </li>
          <li>
            <strong>Orden:</strong> Para asegurar el buen funcionamiento del
            parqueadero y la comodidad de todos los Usuarios, se puede
            restringir el acceso a vehículos que generen obstrucciones o que no
            respeten las normas de estacionamiento. Asimismo, se le puede negar
            el acceso a personas que causen estorbos, molestias, incomodidades
            o daños a la propiedad de Parking o de otros Usuarios.
          </li>
        </ul>

        <p>
          El derecho de admisión se aplica de manera equitativa y de
          conformidad con la legislación vigente, garantizando que la decisión
          de admisión no sea discriminatoria por razones de raza, género,
          religión, orientación sexual, discapacidad, u otras características
          protegidas por la ley. Parking se reserva el derecho de modificar
          estos criterios en función de las necesidades operativas y de
          seguridad.
        </p>

        <h2>IX. Términos y condiciones generales del servicio</h2>

        <p>
          Por la seguridad del vehículo, Parking le solicita tener en cuenta las
          siguientes condiciones de prestación del servicio:
        </p>

        <ul>
          <li>Estacionar en posición de salida.</li>
          <li>Cerrar el vehículo con la alarma activada.</li>
          <li>Solicitar inventario escrito del estado exterior del vehículo.</li>
          <li>
            Para mayor seguridad de su bien, Parking le recomienda asegurar
            debidamente su vehículo y no dejar objetos personales ni de valor
            dentro del mismo.
          </li>
          <li>
            No deje objetos personales dentro de su vehículo toda vez que
            Parking no se hace responsable por su posible pérdida, robo o
            custodia. En todo caso, en cumplimiento del numeral 3 del artículo
            90 del Código de Policía, usted podrá relacionarlos en el formato
            disponible en el punto de pago. No obstante, Parking no es
            responsable de los objetos relacionados.
          </li>
          <li>
            Efectuar reclamo en caso de presentarse alguna inconsistencia antes
            de retirar el vehículo del parqueadero.
          </li>
        </ul>

        <p>Procedimiento de reclamación:</p>

        <ul>
          <li>Presentar el comprobante de ingreso.</li>
          <li>
            Diligenciar el formato denominado “Informe de Accidente y/o Servicio
            al Cliente” y entregárselo al operario.
          </li>
          <li>
            Conservar las pruebas y facilitar las investigaciones de Parking, la
            aseguradora o las autoridades competentes.
          </li>
          <li>Proporcionar la documentación requerida.</li>
          <li>
            Atender el procedimiento e instrucciones impartidas por el personal
            de Parking.
          </li>
          <li>
            Compartir la información personal necesaria para la atención del
            siniestro.
          </li>
          <li>
            Autorizar el uso de sus datos personales conforme a lo establecido
            en la Política de Privacidad de Parking International S.A.S., la
            cual se encuentra disponible en la página web.
          </li>
        </ul>

        <p>
          Parking International S.A.S. dará respuesta dentro de los términos
          establecidos por la ley y, en caso de ser positiva, indicará los pasos
          a seguir.
        </p>

        <p>
          Recuerde que, en caso de daños ocasionados por fuerza mayor, caso
          fortuito, incendio, asonada, terrorismo o actos cometidos por
          terceros, deberá informarse de inmediato a la Empresa y a las
          autoridades correspondientes.
        </p>

        <p>
          El vehículo será entregado en las mismas condiciones registradas al
          momento del ingreso, salvo que presente daños mecánicos, eléctricos u
          otros no atribuibles a nuestro servicio. Para retirar el vehículo,
          deberá presentar el comprobante de ingreso y realizar el pago
          correspondiente por el servicio.
        </p>

        <p>
          El Usuario deberá cuidar el ticket de entrada. Su pérdida debe ser
          denunciada ante las autoridades y ocasiona el pago del valor de la
          reposición. Este tendrá un costo adicional a la tarifa del
          parqueadero.
        </p>

        <p>Nuestro servicio está amparado por póliza de seguro R.C.E.</p>

        <h2>X. Derechos y deberes de los usuarios</h2>

        <p>
          El Usuario gozará de derechos y deberes de conformidad con lo
          establecido en el régimen de protección al consumidor de la Ley 1480
          de 2011.
        </p>

        <p>Entre los derechos del Usuario se encuentran:</p>

        <ul>
          <li>
            Presentar consultas, peticiones, solicitudes, quejas o reclamos de
            manera respetuosa ante Parking.
          </li>
          <li>
            Los Usuarios tienen derecho a conocer la Política de Tratamiento de
            Datos Personales, la cual detalla el uso que se dará a su
            información, los derechos que les asisten en relación con el
            tratamiento de sus datos y los canales de atención disponibles para
            ejercer su derecho de hábeas data. Esta política puede ser consultada
            en el siguiente enlace:{" "}
            <a
              href="https://www.parking.net.co/politicadetratamientodedatospersonales"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.parking.net.co/politicadetratamientodedatospersonales
            </a>
            .
          </li>
          <li>
            Solicitar la cancelación o terminación de la relación comercial con
            Parking.
          </li>
          <li>
            Recibir información completa sobre las tarifas a cobrar por la
            prestación del servicio.
          </li>
          <li>
            Recibir información clara, veraz, transparente y oportuna.
          </li>
          <li>
            El derecho de retracto de conformidad con lo establecido en el
            Capítulo X.
          </li>
        </ul>

        <p>Entre los deberes del Usuario se encuentran:</p>

        <ul>
          <li>
            Ingresar sus Datos Personales de manera veraz al momento de
            registrarse en las Plataformas.
          </li>
          <li>
            Notificar a Parking de cualquier uso no autorizado de su cuenta en
            las Plataformas.
          </li>
          <li>
            Abstenerse de utilizar las Plataformas para realizar actos
            contrarios a la moral, la ley, el orden público y las buenas
            costumbres en contra de Parking, sus operarios y/o de terceros.
          </li>
          <li>Pagar la tarifa generada por el Servicio.</li>
          <li>
            Cumplir con las condiciones de prestación del servicio que se ponen
            de presente en el Capítulo VII de estos T&amp;C.
          </li>
          <li>
            Disponer de fondos suficientes para procesar el pago de los
            servicios solicitados por medio de las Plataformas.
          </li>
          <li>
            Abstenerse de registrar métodos de pago que pertenezcan a terceros
            sin su debida autorización.
          </li>
          <li>
            Registrar los métodos de pago de conformidad con el proceso de
            verificación en las Plataformas.
          </li>
          <li>
            Abstenerse de suplantar la identidad de otros Usuarios.
          </li>
          <li>
            Abstenerse de tener más de una (1) cuenta en las Plataformas con los
            mismos Datos Personales. El Usuario reconoce y acepta que Parking se
            reserva el derecho de desactivar las Cuentas que no cumplan con
            estos parámetros.
          </li>
          <li>
            Tratar de manera respetuosa a los operarios y a los agentes de
            servicio al cliente.
          </li>
          <li>Mantener actualizados sus datos de registro.</li>
          <li>
            Asumir las consecuencias, responsabilidades y los
            perjuicios/daños e inconvenientes que, tanto al Usuario/Cliente
            Corporativo mismo como a terceros, se causen por el uso inadecuado
            de las Plataformas, los mecanismos de autenticación y el
            incumplimiento de las obligaciones que se pactan en estos T&amp;C.
          </li>
        </ul>

        <h2>
          XI. Prevención de Lavado de Activos y Financiación del Terrorismo,
          Financiación para la Proliferación de Armas de Destrucción Masiva
          (SAGRILAFT) y Programa de Transparencia y Ética Empresarial (PTEE)
        </h2>

        <p>
          <strong>a. Reconocimiento y Aceptación:</strong> El Usuario/Cliente
          Corporativo reconoce, entiende y acepta de manera voluntaria e
          inequívoca que Parking, en cumplimiento de la normativa vigente
          colombiana, puede dar por terminado el servicio de forma unilateral
          cuando el Usuario haya sido incluido en listas nacionales e
          internacionales tales como ONU, FINCEN, OFAC (Office of Foreign Assets
          Control), y cualquier otra lista vinculante para Colombia según las
          disposiciones de la Unidad de Información y Análisis Financiero (UIAF)
          y la Superintendencia de Sociedades.
        </p>

        <p>
          <strong>b. Declaración de Origen de Fondos:</strong> El Usuario/Cliente
          Corporativo declara y garantiza que sus recursos tienen un origen
          lícito y provienen directamente del desarrollo de su actividad
          económica y ocupación lícitas. El Usuario/Cliente Corporativo se
          compromete a no utilizar el servicio de Parking para actividades
          ilícitas, incluyendo, pero no limitándose a, el lavado de activos, la
          financiación del terrorismo, corrupción, soborno nacional, soborno
          transnacional o cualquier otra actividad contraria a la ley.
        </p>

        <p>
          <strong>c. Obligaciones del Usuario/Cliente Corporativo:</strong> El
          Usuario/Cliente Corporativo se compromete a:
        </p>

        <ul>
          <li>
            Proporcionar información veraz y completa al momento de su registro
            y durante la utilización del servicio.
          </li>
          <li>
            Actualizar de manera oportuna cualquier cambio en la información
            suministrada que sea relevante para la relación contractual.
          </li>
          <li>
            Abstenerse de realizar transacciones que puedan estar vinculadas a
            actividades ilícitas, incluyendo pero no limitándose a lavado de
            activos, financiación del terrorismo, corrupción o soborno.
          </li>
          <li>
            Cumplir con las políticas de SAGRILAFT y PTEE implementadas por
            Parking, así como con cualquier solicitud de información en el marco
            del monitoreo y prevención de riesgos.
          </li>
          <li>
            Informar inmediatamente a Parking sobre cualquier hecho o
            circunstancia que pueda indicar que los recursos utilizados en la
            transacción no tienen un origen lícito.
          </li>
        </ul>

        <p>
          <strong>d. Facultades de Parking:</strong> Parking se reserva el
          derecho de:
        </p>

        <ul>
          <li>
            Solicitar documentación o realizar verificaciones necesarias para
            comprobar la licitud del origen de los recursos del Usuario/Cliente
            Corporativo.
          </li>
          <li>
            Consultar al Usuario/Cliente Corporativo en listas restrictivas
            nacionales e internacionales para evaluar riesgos y garantizar el
            cumplimiento normativo.
          </li>
          <li>
            Reportar a las autoridades competentes cualquier actividad
            sospechosa que pueda constituir una infracción a las normas de
            prevención de lavado de activos y financiación del terrorismo,
            corrupción, soborno u otros delitos.
          </li>
          <li>
            Suspender o terminar unilateralmente el servicio en caso de detectar
            cualquier actividad sospechosa o indicios de lavado de activos,
            financiación del terrorismo, corrupción, soborno u otros delitos.
            Del mismo modo, podrá ejercer esta facultad si llega a tener
            conocimiento de que el Usuario/Cliente Corporativo se encuentra
            involucrado en una investigación de cualquier tipo (penal,
            administrativa, etc.) relacionada con actividades ilícitas.
          </li>
        </ul>

        <p>
          <strong>e. Cumplimiento Normativo:</strong> Parking se compromete a
          cumplir con todas las obligaciones impuestas por la legislación
          colombiana en materia de prevención de lavado de activos y
          financiación del terrorismo, incluyendo la implementación de un
          Sistema de Autocontrol y Gestión del Riesgo Integral (SAGRILAFT), el
          Programa de Transparencia y Ética Empresarial (PTEE) y a seguir las
          recomendaciones del Grupo de Acción Financiera Internacional (GAFI) y
          de la Unidad de Información y Análisis Financiero (UIAF).
        </p>

        <h2>XII. Modificación de términos y condiciones</h2>

        <p>
          Los presentes T&amp;C son obligatorios y vinculantes para todo Usuario.
          Parking se reserva el derecho de modificar los T&amp;C en cualquier
          momento, mediante la colocación de las nuevas condiciones que serán
          anunciadas en forma explícita y previa a su entrada en vigor, y
          respetando en todo caso los derechos adquiridos por los Usuarios en
          las operaciones realizadas a través de las Plataformas.
        </p>

        <p>
          El Usuario deberá informar por escrito su aceptación o rechazo mediante
          hipervínculos dispuestos para este propósito. Si el Usuario opta por
          rechazar las nuevas condiciones generales, deberá abstenerse de
          utilizar los servicios prestados por Parking. Dentro del plazo
          mencionado anteriormente, el Usuario podrá darse de baja, sin afectar
          los derechos adquiridos en las mensualidades adquiridas.
        </p>

        <p>
          Si pasado el plazo mencionado, el Usuario no ha comunicado su decisión
          a Parking y/o continúa utilizando los servicios de Parking, se
          considerará como una aceptación inequívoca, incondicional e
          irrevocable de las nuevas condiciones. Para aclaraciones o consultas
          sobre el contenido de los Términos y Condiciones, por favor contactar
          al correo electrónico{" "}
          <a href="mailto:administracion@parking.net.co">
            administracion@parking.net.co
          </a>
          .
        </p>

        <p>
          El Usuario expresamente acepta los Términos y Condiciones como
          requisito esencial para el uso de los servicios ofrecidos por Parking.
        </p>
      </article>
          </Col>
        </Row>
      </Container>
    </>
  );
}